import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalSidebarAggQuery, {
	type GoalSidebarAggQuery as GoalSidebarAggQueryType,
} from '../components/GoalSidebar/agg/__generated__/GoalSidebarAggQuery.graphql';

export const goalSidebarAggResource = createRelayResource<GoalSidebarAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';
		const key = routerContext.match.params.id ?? '';
		const isCombinedAggQueryEnabled = fg('townsquare_enable_combined_agg_query_sidebar');

		return {
			query: GoalSidebarAggQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				searchQuery: `key = ${key} AND (archived = false OR archived = true)`,
				containerId,
				isCombinedAggQueryEnabled,
			},
		};
	},
});
